import { isBlockType, isIPOType } from '../../../../../../common/util/offering/offeringTypeHelpers';
import { FilingType, OfferingStatus } from '../../../../../../graphql';
import { SideBar_OfferingDetails_OfferingPartsFragment } from '../../graphql';

export type SidePanelPriceRangeValue =
  | { kind: 'range'; label: string; low: number | null; high: number | null }
  | { kind: 'single'; label: string; value: number | null };

type Offering = Pick<
  SideBar_OfferingDetails_OfferingPartsFragment,
  'status' | 'type' | 'priceRangeLow' | 'priceRangeHigh' | 'terms'
>;

export function getSidePanelPriceRangeValue(offering: Offering): SidePanelPriceRangeValue {
  const { status, type, priceRangeLow, priceRangeHigh, terms } = offering;

  if (status === OfferingStatus.Priced) {
    const offerPrice = terms.filings.find(
      filing => filing.filingType === FilingType.Final
    )?.offerPrice;

    return { kind: 'single', label: 'Offer Price', value: offerPrice ?? null };
  }

  if (status === OfferingStatus.Live && !isIPOType(type)) {
    if (isBlockType(type)) {
      return {
        kind: 'single',
        label: 'LT Before Launch',
        value: terms.followOnPricing?.lastTradeBeforeLaunch ?? null,
      };
    }

    const reOfferLow = terms.followOnPricing?.reOfferLow ?? null;
    const reOfferHigh = terms.followOnPricing?.reOfferHigh ?? null;

    if (reOfferLow === null && reOfferHigh === null) {
      return {
        kind: 'single',
        label: 'LT Before Launch',
        value: terms.followOnPricing?.lastTradeBeforeLaunch ?? null,
      };
    }

    return { kind: 'range', label: 'Re-offer Range', low: reOfferLow, high: reOfferHigh };
  }

  return {
    kind: 'range',
    label: 'Price Range',
    low: priceRangeLow ?? null,
    high: priceRangeHigh ?? null,
  };
}
